export function getThemeFromDomain(): 'kashly' | 'saledesk' {
  const hostname = window.location.hostname;
  if (hostname.includes('getkashly.com')) {
    return 'kashly';
  }
  return 'saledesk';
}

/** Display name for the hosting platform (receipts, PWA defaults, etc.). */
export function getPlatformBrandName(): 'Kashly POS' | 'SaleDesk POS' {
  return getThemeFromDomain() === 'kashly' ? 'Kashly POS' : 'SaleDesk POS';
}

/** i18n key for receipt “Powered by …” line. */
export function getPoweredByI18nKey(): 'receipt.poweredByKashly' | 'receipt.poweredBySaledesk' {
  return getThemeFromDomain() === 'kashly' ? 'receipt.poweredByKashly' : 'receipt.poweredBySaledesk';
}
